import * as actionTypes from './actions';
import { UserDetail } from 'controller/auth';
import { HealthyItem } from 'controller/bs';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UserState {
  user?: Partial<UserDetail>;
  payment: {
    openSetPayment: boolean;
    openConfirmPayment: boolean;
  };
  loading: boolean;
  openKyc: boolean;
}

export const initialState: UserState = {
  user: {},
  payment: {
    openSetPayment: false,
    openConfirmPayment: false
  },
  loading: true,
  openKyc: false
};

export interface ActionType {
  type: string;
  payload: Partial<UserState>;
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    INIT_USER_INFO: (state, action: any) => {
      state = {
        ...initialState
      };
      return state;
    },
    SET_USER_INFO: (state, action: PayloadAction<Partial<UserState>>) => {
      state = {
        ...state,
        ...(action.payload || {})
      };
      return state;
    },
    SET_PAYMENT: (state, action: PayloadAction<Partial<UserState['payment']>>) => {
      state = {
        ...state,
        payment: {
          ...state.payment,
          ...action.payload
        }
      };
      return state;
    }
  }
});

export const { INIT_USER_INFO, SET_USER_INFO, SET_PAYMENT } = userSlice.actions;

export default userSlice.reducer;
